import { render, staticRenderFns } from "./UPDialog.vue?vue&type=template&id=085a95d6&"
import script from "./UPDialog.vue?vue&type=script&lang=ts&"
export * from "./UPDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports